import React from "react";
import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";
import { ArrowRightSolidV6 } from "@shared/v2/Icomoon";
import { useIsPlace } from "../../reducers/layoutReducer/selectors";

const ZoomCard = ({ actions, comingSoon, description, imgClassName, imgSrc, onClick, title }) => {
  const isPlace = useIsPlace();
  return (
    <div className="tw-w-[407px] tw-flex tw-flex-col tw-gap-[20px]">
      <button
        type="button"
        className="tw-group tw-border-none tw-h-[400px] tw-bg-tinted-gray-50 tw-pt-[24px] tw-rounded-[16px] tw-flex tw-flex-col tw-gap-[32px] tw-overflow-hidden"
        onClick={onClick}
      >
        <div className="tw-overflow-hidden tw-min-h-[21px] tw-h-[21px]">
          <h3 className="tw-transition-transform tw-duration-500 group-hover:tw-translate-y-[-21px] tw-m-0 tw-px-[24px] tw-text-16d tw-text-left tw-font-bold tw-uppercase tw-text-gray-50 tw-tracking-[2px]">
            {title}
          </h3>
          <h3 className="tw-transition-transform tw-duration-500 group-hover:tw-translate-y-[-21px] tw-m-0 tw-px-[24px] tw-text-16d tw-text-left tw-font-bold tw-uppercase tw-text-gray-50 tw-tracking-[2px] tw-flex tw-items-center tw-gap-[6px]">
            Learn More <ArrowRightSolidV6 size="l" className="tw-mb-[2px]" />
          </h3>
        </div>
        <div className={`tw-transition-transform tw-duration-500 group-hover:tw-scale-110 ${imgClassName}`}>
          <img src={imgSrc} alt={title} className="tw-w-full" />
        </div>
      </button>
      <div className="tw-px-[16px]">
        <div className="tw-flex tw-items-center tw-gap-[12px] tw-mb-[10px]">
          <span className="tw-text-18d tw-font-bold">{title}</span>
          {comingSoon && (
            <span
              className={`${
                isPlace ? "tw-bg-semantic-blue-5" : "tw-bg-brivity-blue-10"
              } tw-rounded-[4px] tw-px-[8px] tw-py-[4px] tw-text-12d tw-font-bold tw-uppercase tw-text-theme-primary`}
            >
              Coming Soon
            </span>
          )}
          <div className="tw-flex-1 tw-h-[1px] tw-bg-gray-10" />
        </div>
        <Typography className="!tw-text-gray-50 tw-mb-[16px] tw-min-h-[60px]">{description}</Typography>
        <div className="tw-flex tw-items-center tw-gap-[16px]">{actions}</div>
      </div>
    </div>
  );
};

ZoomCard.propTypes = {
  actions: PropTypes.node,
  comingSoon: PropTypes.bool,
  description: PropTypes.string.isRequired,
  imgClassName: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
};

ZoomCard.defaultProps = {
  actions: null,
  comingSoon: false,
  imgClassName: "",
  onClick: () => {},
};

export default ZoomCard;
